export default __webpack_public_path__ + "static/media/TeacherSvg.c4ee9888.svg";